export interface ApiGetPatentValuationResponse {
    // 独立权利要求
    indep_claim_count: number;
    //是否被提过无效或异议
    invalid_opposition: boolean;
    // 简单同族数量
    simple_family_count: number;
    // 简单同族布局国家和地区数量
    simple_family_country: number;
    // 被引用专利数量
    cited_count: number;
    // 发明人数量
    inventor_count: number;
    // 同类技术近3年专利增长率  后面需要跟上%
    growth_rate: number;
    // 是否有许可或转移
    license_or_transfer: boolean;
    // 简单同族中有效专利分布国家/地区
    family_active_area: string[];
    //维持年限
    maintenance_period: number;
}

export type ApiGetPatentValuationRequest = string;

export const GetPatentValuation = Symbol.for('GetPatentValuation');

export interface GetPatentValuation {
    getPatentValuation(patentId: ApiGetPatentValuationRequest): Promise<ApiGetPatentValuationResponse>;
}
